export const PaymentTransactionConstants = {
    MIN_PAYMENT_AMOUNT: 0.01,
    SUCCESS_ALERT_MESSAGE: 'Payment has been successfully processed.',
    ERROR_ALERT_MESSAGE:
        'An error occurred while processing the payment. Please check the payment log below for more details.',
} as const;
